"use client";
import RightContent from "./RightContent";
import LeftContent from "./LeftContent";

const FooterContent = ({data}) => {
    const {footerSocial} = data || {};
    return(
        <>
            <LeftContent footerSocial={footerSocial}/>
            <RightContent {...data}/>
        </>
    );
}

export default FooterContent;